import {
  createTableColumn,
  Link,
  Tooltip,
  Text,
} from "@fluentui/react-components";
import useWindowSize from "../../helpers/useWindowSize";
import { ILSP3ResponseDto } from "../../Models/ILSP3ResponseDto";
import { useState } from "react";
import i18n from "i18next";
import { helperMethods } from "../../helpers/helperMethods";
import { MmInch } from "../../helpers/mminch";
import { baseUrl } from "../../helpers/constants";

function Lsp3BitColumns(preiseSichtbar: boolean) {
  const windowSize = useWindowSize();
  const [clickedArtikel, setClickedArtikel] = useState<
    ILSP3ResponseDto | undefined
  >(undefined);
  const columns = [
    // ------------Artikel------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "artikelId",
      renderHeaderCell: () => {
        return (
          <Tooltip
            content={i18n.t<string>("artikelIdTooltip")}
            relationship="label"
          >
            <Text> {i18n.t<string>("artikelId")}</Text>
          </Tooltip>
        );
      },
      renderCell: (item) => {
        if (windowSize.width > 500) {
          if (
            (item.guid != null || item.artikel.guid != null) &&
            !item.artikelId.startsWith("P")
          ) {
            return (
              <Tooltip
                content={i18n.t<string>("displayTechnicalData")}
                relationship="label"
              >
                <Link
                  target="_blank"
                  href={`${baseUrl}/quickfinder?guid=${
                    item.guid ?? item.artikel.guid
                  }`}
                >
                  {item.artikelId}
                </Link>
              </Tooltip>
            );
          } else {
            return <Text>{item.artikelId}</Text>;
          }
        } else {
          <>
            <Text>{item.artikelId}</Text>
            <Text>
              {item.artikel ? item.artikel.benennungDE : item.benennungDE}
            </Text>
          </>;
        }
      },
    }),
    // ------------ BENNENUNG -------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "benennungId",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("benennung")}</Text>;
      },
      renderCell: (item) => {
        return (
          <Text>
            {i18n.language.includes("de")
              ? item.artikel.benennungDE
              : item.artikel.benennungEN}
          </Text>
        );
      },
    }),
    // --------- nennwite Abtrieb in mm -----------
    createTableColumn<any>({
      columnId: "nennwiteId",
      renderHeaderCell: () => {
        return (
          <Tooltip
            relationship="label"
            content={i18n.t<string>("nennweiteColTooltip")}
          >
            <Text>{i18n.t<string>("nennweiteCol")}</Text>
          </Tooltip>
        );
      },
      renderCell: (item) => {
        return (
          <Text>
            {item.nennweiteAbtrieb == 0 ? "-" : item.nennweiteAbtrieb}
          </Text>
        );
      },
    }),
    // --------- nennwite Abtrieb in inch -----------
    createTableColumn<any>({
      columnId: "nennwiteInchId",
      renderHeaderCell: () => {
        return (
          <Tooltip
            relationship="label"
            content={i18n.t<string>("nennweiteInchColTooltip")}
          >
            <Text>{i18n.t<string>("nennweiteInchCol")}</Text>
          </Tooltip>
        );
      },
      renderCell: (item) => {
        let inch = "";
        if (item?.nennweiteAbtrieb && item?.nennweiteAbtrieb > 0) {
          const mm = helperMethods.nachkomma(item.nennweiteAbtrieb, 2);
          inch = MmInch.toInch(helperMethods.convertToNumber(mm));
        } else inch = "-";
        return <Text>{inch}</Text>;
      },
    }),
    // ------------ Profil Abtrieb -----------
    createTableColumn<any>({
      columnId: "profilAbtriebId",
      renderHeaderCell: () => {
        return <Text>{i18n.t<string>("profilAbtrieb")}</Text>;
      },
      renderCell: (item) => {
        return <Text>{item.profilAbtrieb}</Text>;
      },
    }),
    // ------------ Länge -----------
    createTableColumn<any>({
      columnId: "laengeId",
      renderHeaderCell: () => {
        return <Text>{i18n.t<string>("gesamtlaenge")}</Text>;
      },
      renderCell: (item) => {
        return (
          <Text>
            {item.gesamtlaenge == 0 ? "-" : item.gesamtlaenge?.toLocaleString()}
          </Text>
        );
      },
    }),
  ];
  if (preiseSichtbar) {
    columns.push(
      // ------------preis------------
      createTableColumn<ILSP3ResponseDto>({
        columnId: "preis",
        renderHeaderCell: () => {
          return (
            <Tooltip
              relationship="label"
              content={<div>{i18n.t<string>("preisTooltip")}</div>}
            >
              <Text>
                {i18n.t<string>("preis")}
                <Text style={{ color: "#ff6600", fontWeight: 700 }}>*</Text>
              </Text>
            </Tooltip>
          );
        },
        renderCell: (item) => {
          if (item.hasOwnProperty("artikel") && item.artikel) {
            return (
              <div className="lueb-centerVertical">
                <Text>
                  {item.artikel?.netto
                    ? item.artikel?.netto.toLocaleString(
                        i18n.language.includes("de") ? "de-DE" : "en-EN",
                        { minimumFractionDigits: 2 },
                      ) + " €"
                    : ""}
                </Text>
              </div>
            );
          } else {
            return (
              <div className="lueb-centerVertical">
                <Text>
                  {item.netto
                    ? item.netto.toFixed(2).toLocaleString() + " €"
                    : ""}
                </Text>
              </div>
            );
          }
        },
      }),
    );
  }
  return {
    columns: columns,
    clickedArtikel: clickedArtikel,
  };
}
export default Lsp3BitColumns;
